import script from "./OrdersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdersView.vue?vue&type=script&setup=true&lang=ts"

import "./OrdersView.vue?vue&type=style&index=0&id=fd2991b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd2991b0"]])

export default __exports__